export default __webpack_public_path__ + "static/media/oyrx.e348c10a.jpg";